"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidDatetime = exports.toISO8601 = exports.timestampToHHDDAMPM = exports.timestampToMMDDYYYY = exports.cleanupPropertyName = exports.capitalizeAllWords = exports.capitalizeFirstLetter = void 0;
function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
exports.capitalizeFirstLetter = capitalizeFirstLetter;
function capitalizeAllWords(string) {
    return string
        .split(' ')
        .map(function (word) { return capitalizeFirstLetter(word); })
        .join(' ');
}
exports.capitalizeAllWords = capitalizeAllWords;
function cleanupPropertyName(string) {
    return capitalizeAllWords(string.replace(/_/g, ' '));
}
exports.cleanupPropertyName = cleanupPropertyName;
function timestampToMMDDYYYY(timestamp) {
    var date = new Date(timestamp * 1000);
    var formattedDate = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(date);
    return formattedDate;
}
exports.timestampToMMDDYYYY = timestampToMMDDYYYY;
function timestampToHHDDAMPM(timestamp) {
    var date = new Date(timestamp);
    // Format the time part
    var formattedTime = new Intl.DateTimeFormat('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    }).format(date);
    return formattedTime;
}
exports.timestampToHHDDAMPM = timestampToHHDDAMPM;
function toISO8601(date) {
    var z = function (n) { return (n < 10 ? "0".concat(n) : "".concat(n)); };
    var offset = function (n) { return (n < 0 ? "-".concat(z(n * -1)) : "+".concat(z(n))); };
    var c = new Date(date);
    return "".concat(c.getUTCFullYear(), "-").concat(z(c.getUTCMonth() + 1), "-").concat(z(c.getUTCDate()), "T").concat(z(c.getUTCHours()), ":").concat(z(c.getUTCMinutes()), ":").concat(z(c.getUTCSeconds())).concat(offset(c.getTimezoneOffset() / 60), ":00");
}
exports.toISO8601 = toISO8601;
function isValidDatetime(str) {
    var date = new Date(str);
    // Check if the date object is valid
    return !isNaN(date.getTime());
}
exports.isValidDatetime = isValidDatetime;
